import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isPosAllowed } from "../../../utils/companyCapabilities";

const SettingManagementSidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const profileData = useSelector((state) => state.auth.profileData);
  const compCountry = profileData?.compCountry || "";
  const posAllowed = isPosAllowed(profileData);

  return (
    <div
      className={`menu-item has-sub ${
        location.pathname.startsWith("/setting") ||
        location.pathname.startsWith("/manageDevices") ||
        location.pathname.startsWith("/printingReceipts") ||
        location.pathname.startsWith("/paymentMethod") ||
        location.pathname.startsWith("/setting/Pricing&Subscriptions")
          ? "active"
          : ""
      }`}
    >
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-gear"></i>
        </div>
        <div className="menu-text">Setting</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${currentPath === "/setting" ? "active" : ""}`}
        >
          <NavLink to="/setting" className="menu-link">
            Setting
          </NavLink>
        </div>
        {posAllowed && (
        <div
          className={`menu-item ${
            currentPath === "/managedevices" ? "active" : ""
          }`}
        >
          <NavLink to="/manageDevices" className="menu-link">
            Manage Devices
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${
            currentPath === "/printingreceipts" ? "active" : ""
          }`}
        >
          <NavLink to="/printingReceipts" className="menu-link">
            Printing Receipts
          </NavLink>
        </div>
        )}
        {compCountry?.toLowerCase() !== "pak" && (
          <div
            className={`menu-item ${
              currentPath === "/paymentmethod" ? "active" : ""
            }`}
          >
            <NavLink to="/paymentMethod" className="menu-link">
              Payment Methods
            </NavLink>
          </div>
        )}
        <div
          className={`menu-item ${
            currentPath === "/setting/pricing&subscriptions" ? "active" : ""
          }`}
        >
          <NavLink to="/setting/Pricing&Subscriptions" className="menu-link">
            Pricing & Subscriptions
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SettingManagementSidebar;
